import React from "react";
import { HiChevronDown, HiChevronUp } from "react-icons/hi";

/** Cabecera compacta: título + flechas asc/desc en fila (orden local o remoto). */
export default function ColumnSortHeader({
  label,
  sortKey,
  activeSortBy,
  activeSortDir,
  onSort,
}) {
  const active = activeSortBy === sortKey;
  const ascActive = active && activeSortDir === "asc";
  const descActive = active && activeSortDir === "desc";

  const inactiveBtn =
    "text-gray-400 hover:bg-gray-100 hover:text-gray-600 dark:text-gray-500 dark:hover:bg-white/10 dark:hover:text-gray-300";
  const activeBtn =
    "bg-brand-100 text-brand-700 dark:bg-brand-500/20 dark:text-brand-300";

  return (
    <div className="flex min-w-0 items-center gap-1.5 sm:gap-2">
      <span className="min-w-0 flex-1 text-left text-[11px] font-bold uppercase leading-tight tracking-wide text-gray-600 dark:text-gray-200">
        {label}
      </span>
      <div
        role="group"
        aria-label={`Ordenar por ${label}`}
        className="inline-flex shrink-0 flex-row overflow-hidden rounded-md border border-gray-200/80 bg-white/90 dark:border-white/12 dark:bg-navy-900/60"
      >
        <button
          type="button"
          aria-label={`${label}: ascendente`}
          aria-pressed={ascActive}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onSort(sortKey, "asc");
          }}
          className={`flex h-6 w-6 items-center justify-center border-r border-gray-100 transition-colors duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-brand-400 dark:border-white/10 ${
            ascActive ? activeBtn : inactiveBtn
          }`}
        >
          <HiChevronUp className="h-3 w-3 shrink-0" strokeWidth={2.5} aria-hidden />
        </button>
        <button
          type="button"
          aria-label={`${label}: descendente`}
          aria-pressed={descActive}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onSort(sortKey, "desc");
          }}
          className={`flex h-6 w-6 items-center justify-center transition-colors duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-brand-400 ${
            descActive ? activeBtn : inactiveBtn
          }`}
        >
          <HiChevronDown className="h-3 w-3 shrink-0" strokeWidth={2.5} aria-hidden />
        </button>
      </div>
    </div>
  );
}
